import { StyleSheet } from 'react-native';

import { LAYOUT, THEME } from '../../common';

const { SPACE } = THEME;

export default StyleSheet.create({
  container: LAYOUT.STYLE.ROW,

  rate: {
    marginRight: SPACE.XS,
  },
});
